<div class="w-screen h-screen bg-gradient-blue flex flex-col justify-center items-center space-y-3">
    <img class="w-32 h-32" src="svg/logo-blanco.svg" alt="Logo Blanco">
    <br>

    <span class="text-xs text-center px-10 text-white"> {{ error }}  </span>
    <br>
    <a class="text-white text-xs flex flex-col justify-center items-center" [href]="url" target="_blank">
        Si deseas contactar a tu asesor, haz clic aquí 
        <img class="h-[50px] w-[50px] mt-3" src="svg/whatsapp.svg" alt="whatsapp" >
    </a>
</div>